module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-privacy-policy/master-privacy-policy.component.scss
// module id = ./src/app/master/master-privacy-policy/master-privacy-policy.component.scss
// module chunks = main